import { getApp, getApps, initializeApp, type FirebaseApp, type FirebaseOptions } from "firebase/app";
import { GLOBAL_CONFIG } from "@/global-config";

const normalize = (value?: string) => {
	const trimmed = value?.trim();
	return trimmed ? trimmed : undefined;
};

const firebaseConfig: FirebaseOptions = {
	apiKey: normalize(GLOBAL_CONFIG.firebase.apiKey),
	authDomain: normalize(GLOBAL_CONFIG.firebase.authDomain),
	projectId: normalize(GLOBAL_CONFIG.firebase.projectId),
	storageBucket: normalize(GLOBAL_CONFIG.firebase.storageBucket),
	messagingSenderId: normalize(GLOBAL_CONFIG.firebase.messagingSenderId),
	appId: normalize(GLOBAL_CONFIG.firebase.appId),
	measurementId: normalize(GLOBAL_CONFIG.firebase.measurementId),
};

export const hasFirebaseAnalyticsConfig = Boolean(
	firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId && firebaseConfig.measurementId
);

export function getFirebaseApp(): FirebaseApp | null {
	if (!hasFirebaseAnalyticsConfig) {
		return null;
	}

	return getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
}
